"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE_SKELETON = void 0;
const TITLE_SKELETON = exports.TITLE_SKELETON = 'title-skeleton';
